// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1172":"3ea00023","2944":"a4c5245a","6750":"5c37b23a","8892":"4a1d3698"}[chunkId] + ".chunk.css";
};